import React, { useEffect, useState } from 'react';
import {
    SubLabel,
    LabelStyle,
    LabelParaStyle,
    FlexAlertWrapper,
    TopicText,
    ShowAlertWrapper,
    AlertSaveButtonWrapper,
    ChannelGrpLabel,
    ApplyBtnWrapper,
    ThresHoldInput,
    InfoWrapper,
    ResetThresholdDiv,
    ErrorMessage,
    TitleInput,
    AlertUserList
} from './AlertConfig.styled.js'
import ChannelGroupRadio from '../../Common/ChannelGroup/ChannelGroupRadio.jsx';
import { useDispatch, useSelector } from 'react-redux';
import CustomizeMultiSelect from '../../Common/MultiSelect/CustomizeMultiSelect.jsx';
import SelectForAlert from '../../Common/Select/SelectForAlert.jsx';
import { createAlert, updateAlert } from '../../store/redux/slices/alertSlice.js';
import { setMessage } from '../../store/redux/slices/alertMessageSlice.js';

import styled from 'styled-components';
import { Switch } from '@mui/material';
import QueryString from '../TopicBuilder/MainContent/QueryString/QueryString.js';
import { spacing } from '@mui/system';

const AlertConfigure = ({
    selectedTabs,
    channelData,
    dataVal,
    handleClose
}) => {
    const { editAlert } = useSelector((state) => state.alert)
    const [tempTabs, setTempTabs] = useState([]);
    const [checked, setChecked] = useState(false);
    const [checkedNotify, setCheckedNotify] = useState(false);
    const [tempChannels, setTempChannels] = useState({});
    const [tempDataVal, setTempDataVal] = useState({});

    const [activeTab, setActiveTab] = useState(null);
    const dispatch = useDispatch()

    const { companyBasicDetailsData, teamMemberListData ,personalDetailsData} = useSelector(
        (state) => state.tenantSetting
    );

    const { errorChecker } = useSelector((state) => state.alert) || [];
    useEffect(() => {
        // Deep copy to prevent accidental mutation
        setTempTabs(JSON.parse(JSON.stringify(selectedTabs)));
        setTempChannels(JSON.parse(JSON.stringify(channelData)));
        setTempDataVal(JSON.parse(JSON.stringify(dataVal)));
    }, [selectedTabs, channelData, dataVal]);

    const today = new Date().toISOString().split('T')[0];
    const [activePlatform, setActivePlatform] = useState(null);
    const [selectedNotifyMethod, setSelectedNotifyMethod] = useState('');
    const [perForAlert, setPerForAlert] = useState('');
    const [alertName, setAlertName] = useState('');
    const [scanFreq, setScanFreq] = useState('');

    const [dateAndTime, setDateAndTime] = useState(today);
    const [threshold, setThreshold] = useState(null);
    const infoText = 'Resets the threshold after each alert. When off, the threshold doubles before the next alert.'
    const [trigger, setTrigger] = useState('');
    const [placeHolder, setPlaceHolder] = useState({
        placeHolder_1: 'Select Parameter For Alert',
        placeHolder_category: 'Select Categories',
        placeHolder_2: 'Select Trigger Type',
        placeHolder_3: "Enter Threshold",
        placeHolder_4: 'Select Scan Frequency',
        placeHolder_5: 'Search Users...',
        placeHolder_6: 'Select your preferred notification method'

    });
    const [triggerType, setTriggerType] = useState([
        'Greater than ( > )',
        'Less than ( < )',
        'Equal to ( = )',
        'Increase By ( % )',
        'Decrease By ( % )'
        // 'Spikes above average',
        // 'Drop below average'
        // 'Sudden change detected'
    ]);
    const [menberList, setMenberList] = useState('');

    const [queryString, setQueryString] = useState('');
    const [categories, setCategories] = useState('')
    const [categoriesData, setCategoriesData] = useState([])

    const [PerameterForAlert, setPerameterForAlert] = useState([
        'User Engagement', 'Sentiment', 'Emotions'
    ]);

    const [keywordType, setKeywordType] = useState([
        'Hashtags',
        'Mentions'
    ]);
    const [dateAndTimeOption, setDateAndTimeOption] = useState([
        'Daily',
        'Monthly',
        'Weekly',
        'Quaterly',
        'Yearly',
    ]);
    const [isErrorList, setIsErrorList] = useState(
        {
            perForAlert: '',
            categories: '',
            threshold: '',
            scanFreq: '',
            Date_and_Time: '',
            selectedNotifyMethod: '',
            selectedCategories: '',
            selectedChannels: '',
            selectedJobIds: '',
            alertNameError: '',
            trigger: ''
        }
    );

    const [notifyMethod, setNotifyMethod] = useState([
        {
            label: 'SMS',
            value: 'sms'
        },
        {
            label: 'Email',
            value: 'email'
        }
    ]);
    const changeNotifyVal = (op) => {
        setNotifyMethod((prev) => {
            let updatedList = [...prev];

            // if there was an old selection, insert it back in the same index
            if (selectedNotifyMethod) {
                const idx = notifyMethod.indexOf(selectedNotifyMethod);
                updatedList.splice(idx, 0, selectedNotifyMethod);
            }

            // remove the newly selected one
            updatedList = updatedList.filter((val) => val !== op);

            return updatedList;
        });

        setSelectedNotifyMethod(op);
    };

    const handleChangePerameter = (op) => {
        setPerameterForAlert((prev) => {
            const updatedList = perForAlert
                ? [...prev, perForAlert]
                : [...prev];

            return updatedList.filter((val) => val !== op);
        });
        setPerForAlert(op);
    };

    const changeTriggerType = (op) => {
        setTriggerType((prev) => {
            const updatedList = trigger
                ? [...prev, trigger]
                : [...prev];

            return updatedList.filter((val) => val !== op);
        });
        setTrigger(op);
        setIsErrorList(prev => ({
            ...prev,
            trigger: ''
        }));
    };
    const changeScanFreq = (op) => {
        setScanFreq(op);
        setIsErrorList(prev => ({
            ...prev,
            scanFreq: ''
        }));
    };

    const changeCategories = (op) => {
        setCategoriesData((prev) => {
            const updatedList = categories
                ? [...prev, categories]
                : [...prev];

            return updatedList.filter((val) => val !== op);
        });
        setCategories(op);
        setIsErrorList(prev => ({
            ...prev,
            categories: ''
        }));
    };
    const handleTabClick = (tab) => {

        setActiveTab(activeTab === tab ? null : tab); // Toggle behavior
    };
    const handleChange = (tab) => {
        const updatedTabs = tempTabs.map((item) => ({
            ...item,
            isChecked: item.title === tab.title
        }));

        setTempTabs(updatedTabs);

        const tabKey = tab.title === 'Topic' ? 'topic'
            : tab.title === 'Chatter' ? 'chatter'
                : tab.title === 'News & Blogs' ? 'news'
                    : 'Enterprise';

        // Deep clone ChannelData and dataVal to safely update them
        const updatedChannelData = { ...tempChannels };
        const updatedDataVal = { ...tempDataVal };

        const newCheckStatus = !tab.isChecked;

        // // Update all platforms under the tab group
        // updatedChannelData[tabKey] = updatedChannelData[tabKey].map((platform) => {
        //     const platformTitle = platform.title;

        //     // Update each platform's isChecked
        //     const updatedPlatform = { ...platform, isChecked: newCheckStatus };

        //     // Update each content under that platform
        //     if (updatedDataVal[platformTitle]) {
        //         updatedDataVal[platformTitle] = updatedDataVal[platformTitle].map((d) => ({
        //             ...d,
        //             isChecked: newCheckStatus,
        //         }));
        //     }

        //     return updatedPlatform;
        // });

        updatedChannelData[tabKey] =
            updatedChannelData[tabKey].map((platform, pIndex) => {
                const platformChecked = pIndex === 0;

                // 🔘 CHILD RADIO (select FIRST child only)
                if (updatedDataVal[platform.title]) {
                    updatedDataVal[platform.title] =
                        updatedDataVal[platform.title].map((child, cIndex) => ({
                            ...child,
                            isChecked: platformChecked && cIndex === 0
                        }));
                }

                return {
                    ...platform,
                    isChecked: platformChecked
                };
            });

        // ❌ CLEAR ALL OTHER CATEGORIES
        Object.keys(updatedChannelData).forEach(key => {
            if (key !== tabKey) {
                updatedChannelData[key] =
                    updatedChannelData[key].map(platform => {
                        if (updatedDataVal[platform.title]) {
                            updatedDataVal[platform.title] =
                                updatedDataVal[platform.title].map(child => ({
                                    ...child,
                                    isChecked: false
                                }));
                        }
                        return { ...platform, isChecked: false };
                    });
            }
        });

        // Apply updated states
        setTempChannels(updatedChannelData);
        setTempDataVal(updatedDataVal);
    };
    const handleSubSectionChange = (platformTitle, parentCategory) => {
        console.log("=========handleSubSectionChange=========");
        const categoryKey = parentCategory === 'Topic'
            ? 'topic'
            : parentCategory === 'Chatter'
                ? 'chatter'
                : parentCategory === 'News & Blogs'
                    ? 'news'
                    : 'Enterprise';

        // Clone state
        const updatedChannelData = { ...tempChannels };
        const updatedDataVal = { ...tempDataVal };
        const updatedSelectedTabs = [...tempTabs];

        // 🔥 RADIO: only one platform checked
        updatedChannelData[categoryKey] =
            updatedChannelData[categoryKey].map(platform => {

                const isSelected = platform.title === platformTitle;

                // update children of each platform
                if (updatedDataVal[platform.title]) {
                    updatedDataVal[platform.title] =
                        updatedDataVal[platform.title].map(item => ({
                            ...item,
                            isChecked: false   // only selected platform’s children checked
                        }));
                }

                return {
                    ...platform,
                    isChecked: isSelected
                };
            });

        // 🔥 Parent tab must be checked since one platform is active
        const updatedTabs = updatedSelectedTabs.map(tab =>
            tab.title === parentCategory
                ? { ...tab, isChecked: true }
                : { ...tab, isChecked: false }
        );

        setTempChannels(updatedChannelData);
        setTempDataVal(updatedDataVal);
        setTempTabs(updatedTabs);
        setPerForAlert("");
    };


    const handleChildBoxChecked = (platformTitle, parentCategory, itemIndex) => {
        console.log("=========handleChildBoxChecked=========");

        const categoryKey = parentCategory === 'Topic'
            ? 'topic'
            : parentCategory === 'Chatter'
                ? 'chatter'
                : parentCategory === 'News & Blogs'
                    ? 'news'
                    : 'Enterprise';

        console.log(tempDataVal, "tempDataVal");

        // const updatedDataVal = { ...tempDataVal };
        // const updatedChannelData = { ...tempChannels };
        // const updatedSelectedTabs = [...tempTabs];

        // // 🔥 RADIO: only one child checked
        // updatedDataVal[platformTitle] =
        //     updatedDataVal[platformTitle].map((child, idx) => ({
        //         ...child,
        //         isChecked: idx === itemIndex
        //     }));

        // // 🔥 platform must be checked
        // updatedChannelData[categoryKey] =
        //     updatedChannelData[categoryKey].map(platform =>
        //         platform.title === platformTitle
        //             ? { ...platform, isChecked: true }
        //             : { ...platform, isChecked: false }
        //     );

        // // 🔥 parent tab checked
        // const updatedTabs = updatedSelectedTabs.map(tab =>
        //     tab.title === parentCategory
        //         ? { ...tab, isChecked: true }
        //         : tab
        // );
        const updatedDataVal = { ...tempDataVal };
        const updatedChannelData = { ...tempChannels };
        const updatedTabs = [...tempTabs];

        /* -------------------------------------------------
           🔘 CHILD RADIO (ONLY ONE CHILD ACROSS ALL PLATFORMS)
        -------------------------------------------------- */
        updatedChannelData[categoryKey].forEach(platform => {
            const pTitle = platform.title;

            updatedDataVal[pTitle] =
                updatedDataVal[pTitle]?.map((child, idx) => ({
                    ...child,
                    isChecked:
                        pTitle === platformTitle && idx === itemIndex
                })) || [];
        });

        /* -------------------------------------------------
           🔘 PLATFORM RADIO (ONLY CLICKED PLATFORM CHECKED)
        -------------------------------------------------- */
        updatedChannelData[categoryKey] =
            updatedChannelData[categoryKey].map(platform => ({
                ...platform,
                isChecked: platform.title === platformTitle
            }));

        /* -------------------------------------------------
           🔘 PARENT TAB RADIO (ONLY THIS TAB CHECKED)
        -------------------------------------------------- */
        const updatedSelectedTabs = updatedTabs.map(tab => ({
            ...tab,
            isChecked: tab.title === parentCategory
        }));

        setTempDataVal(updatedDataVal);
        setTempChannels(updatedChannelData);
        // setTempTabs(updatedTabs);
        setTempTabs(updatedSelectedTabs);
        setIsErrorList(prev => ({
            ...prev,
            selectedJobIds: ''
        }));

    };
    const handleSelectPeremeter = (val) => {
        handleChangePerameter(val)
        setCategories('')
        let category1 = []
        let category2 = []
        let category3 = []
        let category4 = []
        let category5 = []
        if (val == 'User Engagement') {
            if (tempChannels?.topic?.[0]?.isChecked == true) {
                category1 = ['Likes', 'Replies', 'Views', 'Reposts']
            } else {
                category1 = []
            }
            if (tempChannels?.topic?.[1]?.isChecked == true) {
                category2 = ['Likes', 'Comments', 'Views']
            } else {
                category2 = []
            }
            if (tempChannels?.topic?.[2]?.isChecked == true) {
                category3 = ['Reactions', 'Comments', 'Shares']
            } else {
                category3 = []
            }
            if (tempChannels?.topic?.[3]?.isChecked == true) {
                category4 = ['Likes', 'Comments', 'Views']
            } else {
                category4 = []
            }
            if (tempChannels?.chatter?.[0]?.isChecked == true) {
                category5 = ['Reviews']
            } else {
                category5 = []
            }

        } else if (val == 'Sentiment') {
            category1 = ['Positive', 'Negative', 'Neutral']
            category2 = []
            category3 = []
            category4 = []
            category5 = []
        } else if (val == 'Emotions') {
            category1 = ['Surprise', 'Joy', 'Neutral', 'Fear', 'Sadness', 'Anger', 'Disgust']
            category2 = []
            category3 = []
            category4 = []
            category5 = []
        } else if (val == 'Posts') {
            if (tempChannels?.topic?.[0]?.isChecked == true) {
                category1 = ['Hashtags', 'Mentions']
            } else {
                category1 = []
            }
            if (tempChannels?.topic?.[1]?.isChecked == true) {
                category2 = ['Hashtags', 'Mentions']
            } else {
                category2 = []
            }
            if (tempChannels?.topic?.[2]?.isChecked == true) {
                category3 = ['Hashtags']
            } else {
                category3 = []
            }
            if (tempChannels?.topic?.[3]?.isChecked == true) {
                category4 = ['Hashtags']
            } else {
                category4 = []
            }
            if (tempChannels?.chatter?.[0]?.isChecked == true) {
                category5 = ['Reviews']
            } else {
                category5 = []
            }
        }


        // collect only non-empty categories
        const allCategories = [category1, category2, category3, category4, category5]?.filter(c => c.length > 0);

        // take intersection
        const intersection =
            allCategories.length > 0
                ? allCategories.reduce((acc, curr) =>
                    acc.filter(item => curr.includes(item))
                )
                : [];


        console.log("Intersection:", intersection);
        setCategoriesData(intersection)

        setIsErrorList(prev => ({
            ...prev,
            perForAlert: ''
        }));
    }

    const memberOptions = teamMemberListData?.map((member) => ({
        label: member.first_name + ' ' + member.last_name,   // or `${member.name} (${member.email})`
        value: member.user_id
    }));


    const handleApply = () => {


        const selectedCategories = tempTabs
            .filter(tab => tab.isChecked)
            .map(tab => tab?.title?.toLowerCase() || '');

        const selectedChannels = [];
        const selectedJobIds = [];

        selectedCategories.forEach(category => {
            const key = category === 'topic' ? 'topic'
                : category === 'chatter' ? 'chatter'
                    : category === 'News & Blogs' ? 'news'
                        : 'Enterprise';

            tempChannels[key]?.forEach(platform => {
                if (platform.isChecked) {
                    if (platform.title === 'X') {

                        selectedChannels.push('twitter');
                    } else {
                        let val = platform?.title?.toLowerCase() || ''
                        selectedChannels.push(val);
                    }
                    // Push only selected job IDs
                    tempDataVal[platform.title]?.forEach(item => {
                        if (item.isChecked) {
                            selectedJobIds.push(item.job_id);
                        }
                    });
                }
            });
        });

        let isError = false;

        if (perForAlert === '' || perForAlert === null || perForAlert === undefined) {
            isError = true;
            setIsErrorList(prev => ({
                ...prev,
                perForAlert: 'Select Parameter'
            }));


            console.log('perForAlert');

        }

        if ((categories === '' || categories === null || categories === undefined)
            &&
            (perForAlert !== 'Grammar Check')) {
            isError = true;

            setIsErrorList(prev => ({
                ...prev,
                categories: 'Select Categories'
            }));
            console.log('categories');
        }

        if ((threshold === '' || threshold === null || threshold === undefined)) {
            if ((perForAlert == 'Grammar Check')) {

            } else {

                isError = true;
                setIsErrorList(prev => ({
                    ...prev,
                    threshold: 'Select Threshold'
                }));
                console.log('threshold');
            }
        }
        if (scanFreq === '' || scanFreq === null || scanFreq === undefined) {
            isError = true;
            setIsErrorList(prev => ({
                ...prev,
                scanFreq: 'Select Trigger Frequency'
            }));
            console.log('scanFreq');
        }
        if ((trigger === '' || trigger === null || trigger === undefined)) {
            if ((perForAlert == 'Grammar Check')) {

            } else {
                isError = true;
                setIsErrorList(prev => ({
                    ...prev,
                    trigger: 'Select Trigger Type'
                }));
                console.log('scanFreq');

            }

        }
        if (dateAndTime === '' || dateAndTime === null || dateAndTime === undefined) {
            isError = true;
            setIsErrorList(prev => ({
                ...prev,
                Date_and_Time: 'Select Alert Start Date'
            }));
            console.log('Date');
        }

        if ((selectedNotifyMethod === '' || selectedNotifyMethod === null || selectedNotifyMethod === undefined || selectedNotifyMethod.length === 0)) {
            isError = true;
            setIsErrorList(prev => ({
                ...prev,
                selectedNotifyMethod: 'Select Notify Method'
            }));
            // console.log(checkedNotify,"checkedNotify",'selectedNotifyMethod');
        }

        // if (menberList === '' || menberList === null || menberList === undefined || menberList.length === 0) {
        //     isError = true;
        //     isErrorList.push('menberList');
        //     console.log('menberList');
        // }

        if (selectedCategories === '' || selectedCategories === null || selectedCategories === undefined || selectedCategories.length === 0) {
            isError = true;
            setIsErrorList(prev => ({
                ...prev,
                selectedCategories: 'Select Categories'
            }));
            console.log('selectedCategories');
        }

        if (selectedChannels === '' || selectedChannels === null || selectedChannels === undefined || selectedChannels.length === 0) {
            isError = true;
            setIsErrorList(prev => ({
                ...prev,
                selectedChannels: 'Select Channel'
            }));
            console.log('selectedChannels');
        }

        if (selectedJobIds === '' || selectedJobIds === null || selectedJobIds === undefined || selectedJobIds.length === 0) {
            isError = true;
            setIsErrorList(prev => ({
                ...prev,
                selectedJobIds: 'Select Any one Topic'
            }));
            console.log('selectedJobIds');
        }
        if (perForAlert == 'Posts' && categories == 'Engagement Alert' && (queryString.length === '' || queryString === false)) {
            isError = true;
            setIsErrorList(prev => ({
                ...prev,
                selectedEngagementQuery: 'Select Engagement'
            }));
            console.log('selectedEngagementQuery');
        }
        if (alertName == '' || alertName === null || alertName === undefined) {
            isError = true;
            setIsErrorList(prev => ({
                ...prev,
                alertNameError: 'Enter a valid Alert Name'
            }));
            console.log('alertNameError');
        }

        if (isError) {
            // dispatch(setMessage({ message: 'Please select all the mandatory fields', type: 'rejected' }));
            return;
        }
        const selectedJobs = selectedJobIds.map((i) => {
            const today = new Date();
            const formattedDate = today.toISOString().slice(0, 10); // "YYYY-MM-DD"
            if (editAlert) {
                return {
                    job_id: i,
                    updated_at: formattedDate,
                    "previous_value": editAlert?.job_id?.[0]?.previous_value || null,
                    "reset_date": editAlert?.job_id?.[0]?.reset_date || null,
                    "updated_time_stamp": editAlert?.job_id?.[0]?.updated_time_stamp || null,
                };
            }
            return {
                job_id: i,
                updated_at: formattedDate
            };
        });
        let alert_tags = (queryString.length === '' || queryString === false) ? '' : queryString

        if (editAlert) {
            let brandUser = JSON.parse(sessionStorage.getItem("brandUser"));
            let body = {
                ...editAlert,
                "alert_tags": alert_tags,
                "alert_name": alertName,
                "parameter": perForAlert,
                "categories": perForAlert == 'Grammar Check' ? '' : categories,
                "threshold": perForAlert == 'Grammar Check' ? 0 : threshold ? threshold : 0,
                "scan_frequency": scanFreq,
                "notify_method": selectedNotifyMethod ? selectedNotifyMethod : null,
                "alert_user": memberOptions,
                "category": selectedCategories,
                "channel": selectedChannels,
                "job_id": selectedJobs,
                // "send_notification":checkedNotify,
                // "creation_date":editAlert?.creation_date,
                "is_active": editAlert?.is_active,
                "triggered_alerts": [],
                "creation_date": new Date(editAlert?.creation_date).toISOString().split("T")[0],
                "created_by":editAlert?.created_by || brandUser?.user_details?.user_id || 0,


                "reset": {
                    is_reset: perForAlert == 'Grammar Check' ? true : checked,
                    reset_date: editAlert?.reset?.reset_date || null

                },
                "trigger_type": perForAlert == 'Grammar Check' ? '' : trigger,
                "alert_trigger_date": dateAndTime,



            }
            try {
                dispatch(updateAlert({ body }))
                    .then((data) => {
                        if (data?.payload?.message == 'Alert session updated successfully') {

                            dispatch(
                                setMessage({
                                    message:
                                        data?.payload?.message,
                                    // timer: 'off',
                                    type: 'Success',
                                })
                            );
                            handleClose(false)
                        }
                        
                        if (data?.error?.message == 'Rejected') {
                            if (data?.payload?.check_if_alert == 'all_with_alert_name') {
                                console.log("all_with_alert_name");
                                setIsErrorList(prev => ({
                                    ...prev,
                                    perForAlert: 'Select Valid Parameter',
                                    categories: 'Select Valid Categories',
                                    scanFreq: 'Select Valid Trigger Frequency',
                                    selectedNotifyMethod: 'Select Valid Notify Method',
                                    selectedChannels: 'Select Valid Channel',
                                    selectedJobIds: 'Select Valid Title',
                                    alertNameError: 'Enter Unique Alert Name',
                                    trigger: 'Select Valid Trigger Type',
                                    threshold: 'Select Valid Threshold'
                                }));

                            } else if (data?.payload?.check_if_alert == 'all_with_out') {
                                console.log("all_with_out");
                                setIsErrorList(prev => ({
                                    ...prev,
                                    perForAlert: 'Select Valid Parameter',
                                    categories: 'Select Valid Categories',
                                    scanFreq: 'Select Valid Trigger Frequency',
                                    selectedNotifyMethod: 'Select Valid Notify Method',
                                    selectedChannels: 'Select Valid Channel',
                                    selectedJobIds: 'Select Valid Title',
                                    trigger: 'Select Valid Trigger Type',
                                    threshold: 'Select Valid Threshold',
                                    alertNameError:''
                                }));

                            } else if (data?.payload?.check_if_alert == 'alert_name') {
                                console.log("alert_name");
                                setIsErrorList(prev => ({
                                    ...prev,
                                    alertNameError: 'Enter Unique Alert Name',                                    
                                    perForAlert: '',
                                    categories:'',
                                    scanFreq: '',
                                    selectedNotifyMethod: '',
                                    selectedChannels: '',
                                    selectedJobIds: '',
                                    trigger: '',
                                    threshold: ''
                                }));

                            }
                        }

                    }
                    )
                    .catch((e) => {
                        console.log(e, 'error in alert');

                    })
            } catch (e) {
                console.log(e);
            }
        } else {
            

            let brandUser = JSON.parse(sessionStorage.getItem("brandUser"));
            let body = {
                "alert_name": alertName,
                "parameter": perForAlert,
                "categories": perForAlert == 'Grammar Check' ? '' : categories,
                "threshold": perForAlert == 'Grammar Check' ? 0 : threshold ? threshold : 0,
                "scan_frequency": scanFreq,
                "notify_method": selectedNotifyMethod ? selectedNotifyMethod : null,
                "alert_user": memberOptions,
                "category": selectedCategories,
                "channel": selectedChannels,
                "job_id": selectedJobs,
                "alert_tags": alert_tags,
                // "send_notification":checkedNotify,
                "reset": {
                    is_reset: perForAlert == 'Grammar Check' ? true : checked,
                    reset_date: null
                },
                "trigger_type": trigger,
                "alert_trigger_date": dateAndTime,
                "created_by":brandUser?.user_details?.user_id || 0


            }
            console.log(body, "body", menberList);
            try {
                dispatch(createAlert({ body }))
                    .then((data) => {
                        if (data?.payload?.message == 'Alert session created successfully') {

                            dispatch(
                                setMessage({
                                    message:
                                        data?.payload?.message,
                                    // timer: 'off',
                                    type: 'Success',
                                })
                            );
                            handleClose(false)
                        }

                        if (data?.error?.message == 'Rejected') {
                            if (data?.payload?.check_if_alert == 'all_with_alert_name') {
                                console.log("all_with_alert_name");
                                setIsErrorList(prev => ({
                                    ...prev,
                                    perForAlert: 'Select Valid Parameter',
                                    categories: 'Select Valid Categories',
                                    scanFreq: 'Select Valid Trigger Frequency',
                                    selectedNotifyMethod: 'Select Valid Notify Method',
                                    selectedChannels: 'Select Valid Channel',
                                    selectedJobIds: 'Select Valid Title',
                                    alertNameError: 'Enter Unique Alert Name',
                                    trigger: 'Select Valid Trigger Type',
                                    threshold: 'Select Valid Threshold'
                                }));

                            } else if (data?.payload?.check_if_alert == 'all_with_out') {
                                console.log("all_with_out");
                                setIsErrorList(prev => ({
                                    ...prev,
                                    perForAlert: 'Select Valid Parameter',
                                    categories: 'Select Valid Categories',
                                    scanFreq: 'Select Valid Trigger Frequency',
                                    selectedNotifyMethod: 'Select Valid Notify Method',
                                    selectedChannels: 'Select Valid Channel',
                                    selectedJobIds: 'Select Valid Title',
                                    trigger: 'Select Valid Trigger Type',
                                    threshold: 'Select Valid Threshold',
                                    alertNameError:''
                                }));

                            } else if (data?.payload?.check_if_alert == 'alert_name') {
                                console.log("alert_name");
                                setIsErrorList(prev => ({
                                    ...prev,
                                    alertNameError: 'Enter Unique Alert Name',                                    
                                    perForAlert: '',
                                    categories:'',
                                    scanFreq: '',
                                    selectedNotifyMethod: '',
                                    selectedChannels: '',
                                    selectedJobIds: '',
                                    trigger: '',
                                    threshold: ''
                                }));

                            }
                        }

                    }
                    )
                    .catch((e) => {
                        console.log(e, 'error in alert');

                    })
            } catch (e) {
                console.log(e);
            }
        }




    }

    const StyledSwitch = styled(Switch)(({is_custom}) => ({
        width: '45px !important',
        height: '25px !important',
        padding: '1px !important',
        borderRadius: '12px',
        '& .MuiSwitch-root': {

            padding: 0,
        },
        '& .MuiSwitch-switchBase': {
            padding: 0,
            transform: 'translateY(5px) translateX(5px)',
            transition: 'transform 0.3s ease',
            '&.Mui-checked': {
                color: 'red',
                transform: 'translateY(5px) translateX(25px)',
                transition: 'transform 0.3s ease',
                // transform: 'translateX(40px)',
                '& + .MuiSwitch-track': {
                    opacity: 1,
                    backgroundColor: is_custom ? is_custom : 'rgba(45, 137, 85, 1)',
                },
            },
        },
        '& .MuiSwitch-thumb': {
            backgroundColor: 'rgb(255 255 255)',
            height: 15,
            width: 15
        },
        '& .MuiSwitch-track': {
            borderRadius: 33 / 2,
            backgroundColor: 'rgb(191 184 184)',
            opacity: 1,
            padding: 0,
            transition: 'background-color 0.3s ease',
        },
    }));

    const DEFAULT_TABS = [
        { title: 'Topic', key: 'topic' },
        { title: 'Chatter', key: 'chatter' },
        { title: 'News & Blogs', key: 'news' },
        { title: 'Entertainment', key: 'entertainment' }
    ];

    const DEFAULT_CHANNELS = {
        topic: ['X', 'Instagram'],
        chatter: ['flipkart'],
        news: ['news'],
        entertainment: ['Entertainment']
    };
    const mapChannel = (ch) => {
        const map = {
            X: 'twitter',
            YouTube: 'youtube',
            Instagram: 'instagram',
            Facebook: 'facebook',
            flipkart: 'flipkart'
        };
        return map[ch] || ch?.toLowerCase();
    };
    function selectOnlyOne(jobIdList) {
        const selectedIds = jobIdList.map(j => j.job_id);
        const updated = {};

        Object.keys(dataVal).forEach(channel => {
            console.log(dataVal[channel], selectedIds, "channel");

            updated[channel] = dataVal[channel].map(item => ({
                ...item,
                isChecked: selectedIds.includes(item.job_id)
            }));
        });

        return updated;
    }




    function convertEditAlert(editAlert) {
        // ---- Selected Tabs ----
        const selectedTabs = DEFAULT_TABS.map(tab => ({
            title: tab.title,
            isChecked: editAlert?.category?.includes(tab.key) || false,
            disable: !editAlert?.category?.includes(tab.key)
        }));


        // ---- Channel Data ----
        const channelData = {};

        DEFAULT_TABS.forEach(tab => {
            const key = tab.key;
            const channels = DEFAULT_CHANNELS[key];

            channelData[key] = channels.map(ch => ({
                title: ch,
                isChecked: !!editAlert?.channel?.includes(mapChannel(ch)),
                disable: !editAlert?.channel?.includes(mapChannel(ch))
            }));
        });
        // editAlert?.job_id.map((i) => selectOnlyOne(i?.job_id))

        // usage
        const updatedData = selectOnlyOne(editAlert?.job_id || []);

        setTempDataVal(updatedData);


        return { selectedTabs, channelData };
    }


    useEffect(() => {
        if (editAlert) {
            setPlaceHolder(prev => ({
                ...prev,
                placeHolder_1: editAlert?.parameter,
                placeHolder_category: editAlert?.categories,
                placeHolder_2: editAlert?.trigger_type,
                placeHolder_4: editAlert?.scan_frequency,
                placeHolder_6: 'Select your preferred notification method'

            }));
            setMenberList(editAlert?.alert_user)
            // setCategories(editAlert?.categories)
            handleSelectPeremeter(editAlert?.parameter)
            changeTriggerType(editAlert?.trigger_type)
            setThreshold(editAlert?.threshold)
            changeScanFreq(editAlert?.scan_frequency)
            changeNotifyVal(editAlert?.notify_method)
            setDateAndTime(editAlert?.alert_trigger_date)
            setChecked(editAlert?.reset?.is_reset)
            // setCheckedNotify(editAlert?.send_notification)
            
            changeCategories(editAlert?.categories)
            setAlertName(editAlert?.alert_name)
            // setQueryString(editAlert?.alert_tags)
            // setQueryArrays(parseInputTag)


            const { selectedTabs, channelData } = convertEditAlert(editAlert);

            setTempTabs(selectedTabs);
            setTempChannels(channelData);
        }
    }, [editAlert])
    const getCheckedItem = (data) => {
        for (const platform in data) {
            console.log();

            const found = data[platform].find(item => item.isChecked);
            if (found) {

                return {
                    platform,
                    ...found
                };
            }
        }
        return null;
    };
    const getCheckedValue = (data) => {
        const result = [];

        Object.entries(data).forEach(([category, items]) => {
            items.forEach(item => {
                if (item.isChecked) {
                    console.log("found", item);

                    result.push({
                        category,
                        ...item
                    });
                }
            });
        });
        // if (result?.length > 0 && result?.[0]?.title === 'X') {
        //     setPerameterForAlert(['User Engagement', 'Sentiment', 'Emotions'])

        // }

        return result;
    };

    const selectedValue = getCheckedItem(tempDataVal);
    const checkedValues = getCheckedValue(tempChannels);
    console.log(checkedValues, "checkedValues");

    console.log(selectedValue, "selectedValue");


    console.log(tempTabs, "tempTabs", tempChannels, tempDataVal);

    const handleAlertNameChange = (val) => {
        setIsErrorList(prev => ({
            ...prev,
            alertNameError: ''
        }));
        setAlertName(val)
    }
    const handleChangeThreshold = (val) => {
        setIsErrorList(prev => ({
            ...prev,
            threshold: ''
        }));
        setThreshold(val)

    }

    return (
        <ShowAlertWrapper >
            <AlertSaveButtonWrapper >
                <div>
                    <TopicText>Alert Configuration</TopicText>
                    <SubLabel>Configure notification thresholds for metric spikes.</SubLabel>
                </div>
            </AlertSaveButtonWrapper>
            <ChannelGrpLabel>
                <div className='title'>Channel Groups <span className='mandatory' style={{ color: 'red', marginLeft: '-4px' }}>*</span></div>
                <div className='desc' style={{ marginTop: '5px' }}>Select a Channel group to Set Alert</div>
            </ChannelGrpLabel>
            <ChannelGroupRadio
                personalDetailsData={personalDetailsData}
                tempTabs={tempTabs}
                handleChange={handleChange}
                handleSubSectionChange={handleSubSectionChange}
                handleChildBoxChecked={handleChildBoxChecked}
                handleTabClick={handleTabClick}
                activeTab={activeTab}
                tempChannels={tempChannels}
                activePlatform={activePlatform}
                setActivePlatform={setActivePlatform}
                tempDataVal={tempDataVal}
                showEnterprise={true}
            />
            <FlexAlertWrapper style={{
                borderTop: '1px solid rgba(181, 181, 181, 1)'
            }}><div style={{
                marginTop: '20px',
                textAlign: 'left'
            }}>
                    <LabelStyle>Name your Alert <span className='mandatory' style={{ marginLeft: '-4px' }}>*</span></LabelStyle>
                    <br />
                    <LabelParaStyle
                    >
                        Give your alert a clear name so you can easily identify it later.
                    </LabelParaStyle>

                    <div style={{
                        position: 'relative',
                        boxSizing: 'border-box',

                        display: 'block',
                        unicodeBidi: 'isolate'

                    }}>
                        <TitleInput
                            isError={isErrorList?.alertNameError}
                            value={alertName}
                            placeholder={"Alert Name"}
                            disable={true}
                            selectHeight={'22px'}
                            onChange={(e) => handleAlertNameChange(e.target.value)}

                        />


                        {isErrorList?.alertNameError && <ErrorMessage>{isErrorList?.alertNameError}</ErrorMessage>}

                    </div>
                </div>
                <div style={{
                    marginTop: '33px',
                    textAlign: 'left',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <LabelStyle>Channel <span className='mandatory' style={{ marginLeft: '-4px' }}>*</span></LabelStyle>
                    <br />

                    <div style={{
                        position: 'relative',
                        boxSizing: 'border-box',

                        display: 'block',
                        unicodeBidi: 'isolate'

                    }}>

                        <TitleInput
                            isError={isErrorList?.selectedChannels}
                            value={checkedValues?.[0]?.title || ''}
                            placeholder={checkedValues?.[0]?.title || ''}
                            disable={true}
                            selectHeight={'22px'}
                        />
                        {isErrorList?.selectedChannels && <ErrorMessage>{isErrorList?.selectedChannels}</ErrorMessage>}

                    </div>
                </div>
                {
                    checkedValues?.[0]?.title === 'Instagram' ?
                        <div style={{
                            marginTop: '33px',
                            textAlign: 'left',
                            display: 'flex',
                            flexDirection: 'column'
                        }}>
                            <LabelStyle>Search Type <span className='mandatory' style={{ marginLeft: '-4px' }}>*</span></LabelStyle>
                            <br />

                            <div style={{
                                position: 'relative',
                                boxSizing: 'border-box',

                                display: 'block',
                                unicodeBidi: 'isolate'

                            }}>
                                <TitleInput

                                    isError={isErrorList?.selectedJobIds}
                                    value={selectedValue?.search_type == 'user' ? 'Account' : selectedValue?.search_type == 'hashtag' ? 'Hashtag' : '' || ''}
                                    placeholder={selectedValue?.search_type == 'user' ? 'Account' : selectedValue?.search_type == 'hashtag' ? 'Hashtag' : '' || ''}
                                    disable={true}
                                    selectHeight={'22px'}
                                />

                            </div>
                        </div>
                        :
                        <></>
                }

                <div style={{
                    marginTop: '33px',
                    textAlign: 'left',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <LabelStyle>Topic Title <span className='mandatory' style={{marginLeft:'-4px' }}>*</span></LabelStyle>
                    <br />
                    <div style={{
                        position: 'relative',
                        boxSizing: 'border-box',

                        display: 'block',
                        unicodeBidi: 'isolate'

                    }}>
                        <TitleInput
                            isError={isErrorList?.selectedJobIds}
                            value={selectedValue?.title || ''}
                            placeholder={selectedValue?.title || ''}
                            disable={true}
                            selectHeight={'22px'}
                        />

                        {isErrorList?.selectedJobIds && <ErrorMessage>{isErrorList?.selectedJobIds}</ErrorMessage>}

                    </div>
                </div>

                <div style={{
                    marginTop: '20px',
                    textAlign: 'left'
                }}>
                    <LabelStyle>Parameters for Alerting <span className='mandatory' style={{marginLeft:'-4px'}}>*</span></LabelStyle>
                    <br />
                    <LabelParaStyle
                    >
                        Configure alerts based on the following parameters
                    </LabelParaStyle>
                    <SelectForAlert
                        value={perForAlert}
                        placeholder={placeHolder?.placeHolder_1}
                        option={
                            checkedValues?.[0]?.title == 'Instagram'
                                ? ['User Engagement', 'Sentiment', 'Emotions', 'Grammar Check'] :

                                checkedValues?.[0]?.title == 'X'
                                    ? ['User Engagement', 'Sentiment', 'Emotions'] :
                                    PerameterForAlert}
                        onChange={(val) => handleSelectPeremeter(val)}
                        selectHeight={'22px'}
                        error={isErrorList?.perForAlert}

                    />
                </div>



                {(categoriesData?.length == 0 && categories == '') || (perForAlert === 'Grammar Check') ? <></> :
                    <div style={{
                        marginTop: '20px',
                        textAlign: 'left'
                    }}>
                        <LabelStyle>Categories  <span className='mandatory' style={{marginLeft: '-4px'}}>*</span>
                        </LabelStyle>
                        <br />
                        <LabelParaStyle
                            style={{
                                display: 'inline-block',
                                marginTop: "5px",
                                marginBottom: '10px',
                                // marginLeft: '8px',
                                color: 'rgb(99, 99, 99)',
                                fontFamily: "Open Sans",
                                fontSize: '13px',
                                fontWeight: '400'
                            }}
                        >
                            Choose focused categories to monitor
                        </LabelParaStyle>
                        <SelectForAlert
                            value={categories}
                            placeholder={placeHolder?.placeHolder_category}
                            option={perForAlert == 'Posts' ? ['Engagement Alert', 'Grammar Alert'] : categoriesData}
                            onChange={(val) => changeCategories(val)}
                            selectHeight={'22px'}

                            error={isErrorList?.categories}
                        />
                    </div>}
                {
                    perForAlert === 'Grammar Check' ? <></>
                        :
                        <>

                            <div style={{
                                marginTop: '20px',
                                textAlign: 'left'
                            }}>
                                <LabelStyle>Trigger Type  <span className='mandatory' style={{marginLeft: '-4px'}}>*</span>
                                </LabelStyle>
                                <br />
                                <LabelParaStyle>
                                    Select the dropdown to set the Trigger
                                </LabelParaStyle>

                                <SelectForAlert
                                    value={trigger}
                                    placeholder={placeHolder?.placeHolder_2}
                                    option={triggerType}
                                    onChange={(val) => changeTriggerType(val)}
                                    selectHeight={'22px'}

                                    error={isErrorList?.trigger}
                                />
                            </div>
                            <div style={{
                                marginTop: '20px',
                                textAlign: 'left'
                            }}>
                                <ResetThresholdDiv>
                                    <div>

                                        <LabelStyle>Threshold Configuration <span className='mandatory' style={{marginLeft: '-4px'}}>*</span>
                                        </LabelStyle>

                                        <br />
                                    </div>
                                    <div className='child1' style={{ alignItems: 'normal' }}>
                                        Reset Alert
                                        <StyledSwitch
                                        is_custom={personalDetailsData?.is_custom == 'custom' && personalDetailsData?.selected_items ? personalDetailsData?.selected_items :'green'}
                                            checked={checked}
                                            onChange={(e) => setChecked(e.target.checked)}
                                        />
                                        <InfoWrapper>
                                            <div className='infoIcon'>
                                                i
                                                {typeof infoText === 'string' ? (
                                                    <div className='infoText'>{infoText}</div>
                                                ) : (
                                                    <div className='infoText'>
                                                        <ul>
                                                            {infoText.map((el, i) => (
                                                                <li key={i}>{el}</li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                )}
                                            </div>
                                        </InfoWrapper>

                                    </div>
                                </ResetThresholdDiv>

                                <LabelParaStyle>
                                    Set a limit to trigger an alert when exceeded.
                                </LabelParaStyle>

                                <ThresHoldInput
                                    isError={isErrorList?.threshold}
                                    value={threshold ?? ''} // ensures it doesn’t show “null”
                                    type="number"
                                    placeholder={placeHolder?.placeHolder_3}
                                    onChange={(e) => handleChangeThreshold(e.target.value)}
                                />
                                {isErrorList?.threshold && <ErrorMessage>{isErrorList?.threshold}</ErrorMessage>}


                            </div>
                        </>
                }


                <div style={{
                    marginTop: '20px',
                    textAlign: 'left'
                }}>
                    <LabelStyle>Trigger Frequency  <span className='mandatory' style={{marginLeft: '-4px'}}>*</span>
                    </LabelStyle>
                    <br />
                    <LabelParaStyle
                        style={{
                            display: 'inline-block',
                            marginTop: "5px",
                            marginBottom: '10px',
                            // marginLeft: '8px',
                            color: 'rgb(99, 99, 99)',
                            fontFamily: "Open Sans",
                            fontSize: '13px',
                            fontWeight: '400'
                        }}
                    >
                        Define the time interval to scan platform
                    </LabelParaStyle>
                    <SelectForAlert
                        value={scanFreq}
                        placeholder={placeHolder?.placeHolder_4}
                        option={checkedValues?.[0]?.title == 'Instagram' ? ['Hourly', 'Daily', 'Monthly', 'Weekly', 'Quaterly', 'Yearly',] : dateAndTimeOption}
                        onChange={(val) => changeScanFreq(val)}
                        selectHeight={'22px'}

                        error={isErrorList?.scanFreq}
                    />
                </div>

                <div style={{
                    marginTop: '20px',
                    textAlign: 'left'
                }}>
                    <LabelStyle>Alert Start Date <span className='mandatory' style={{marginLeft: '-4px'}}>*</span>
                    </LabelStyle>
                    <br />
                    <LabelParaStyle
                        style={{
                            display: 'inline-block',
                            marginTop: "5px",
                            marginBottom: '10px',
                            // marginLeft: '8px',
                            color: 'rgb(99, 99, 99)',
                            fontFamily: "Open Sans",
                            fontSize: '13px',
                            fontWeight: '400'
                        }}
                    >
                        Define the time interval to scan platforms
                    </LabelParaStyle>
                    {/* <SelectForAlert
                        value={dateAndTime}
                        placeholder='Select Date and Time'
                        option={ScanFreqValue}
                        onChange={(val) => changeDateAndTime(val)}
                        selectHeight={'22px'}
                    /> */}

                    <ThresHoldInput
                        isError={isErrorList?.Date_and_Time}
                        min={today}
                        value={dateAndTime ?? ''} // ensures it doesn’t show “null”
                        type="date"
                        onChange={(e) => setDateAndTime(e.target.value)}
                    // placeholder="Enter Threshold"
                    // onChange={(e) => setThreshold(e.target.value)}
                    />
                    {isErrorList?.Date_and_Time && <ErrorMessage>{isErrorList?.Date_and_Time}</ErrorMessage>}


                </div>
            </FlexAlertWrapper>

            <AlertSaveButtonWrapper >
                <div>
                    <TopicText>User Notifications</TopicText>
                    <SubLabel>Select users and set your preferred method for receiving alerts.</SubLabel>
                </div>
            </AlertSaveButtonWrapper>
            <FlexAlertWrapper style={{ display: 'flex' }}>

                <div style={{
                    marginTop: '20px',
                    width: '48%',
                    textAlign: 'left'
                }}>
                    <LabelStyle>Alert selected users <span className='mandatory' style={{marginLeft: '-4px'}}>*</span>
                    </LabelStyle>
                    {/* <CustomizeMultiSelect
                        value={menberList}
                        setValue={setMenberList}
                        placeholder={placeHolder?.placeHolder_5}
                        language={memberOptions}
                        singleSelect={false}
                    /> */}
                    <AlertUserList>
                        {`${memberOptions?.map(i => i.label).join(", ")}.`}
                    </AlertUserList>

                </div>
                <div style={{
                    marginTop: '20px',
                    width: '48%',
                    textAlign: 'left'
                }}>
                    
                                <ResetThresholdDiv style={{gridTemplateColumns: '68% 30%'}}>
                                    <div>

                                        <LabelStyle>Alert notification method<span className='mandatory' style={{marginLeft: '-1px'}}>*</span>
                                        </LabelStyle>

                                        <br />
                                    </div>
                                    {/* <div className='child1' style={{ alignItems: 'normal',gridTemplateColumns:'69% 25%' ,height:'25px',justifyContent:'center',alignItems:'center'}}>
                                        Notifications
                                        <StyledSwitch
                                            checked={checkedNotify}
                                            onChange={(e) => setCheckedNotify(e.target.checked)}
                                        />

                                    </div> */}
                                </ResetThresholdDiv>
                    {/* <LabelStyle> Alert notification method<span className='mandatory'>*</span>
                    <div>Notifications </div>
                    </LabelStyle> */}
                    <div style={{ marginTop: '10px' }}>
                        {/* <SelectForAlert
                            value={selectedNotifyMethod}
                            placeholder={placeHolder?.placeHolder_6}
                            option={notifyMethod}
                            onChange={(val) => changeNotifyVal(val)}
                            selectHeight={'22px'}
                        /> */}
                        <CustomizeMultiSelect
                            value={selectedNotifyMethod}
                            setValue={setSelectedNotifyMethod}
                            placeholder={placeHolder?.placeHolder_6}
                            language={notifyMethod}
                            singleSelect={false}
                            isError={isErrorList?.selectedNotifyMethod}
                            setIsErrorList={setIsErrorList}
                        />

                        {isErrorList?.selectedNotifyMethod && <ErrorMessage>{isErrorList?.selectedNotifyMethod}</ErrorMessage>}
                    </div>
                </div>
            </FlexAlertWrapper>
            <div>
                <ApplyBtnWrapper>
                    <div className='cancelBtn' onClick={() => handleClose(false)}>Cancel</div>
                    <div className='applyBtn' onClick={() => handleApply()} 
                        style={{
                            background:personalDetailsData?.is_custom == 'custom' && personalDetailsData?.selected_items ? personalDetailsData?.selected_items :'linear-gradient(180deg, #0B7263 0%, #5AA942 100%)'}}>{editAlert ? 'Update Alert' : 'Set Alert'}</div>
                </ApplyBtnWrapper>
            </div>
        </ShowAlertWrapper >
    );
};
export default AlertConfigure;